import axios from "axios";
import { useEffect, useState } from "react";

export const useFetchData = () => {
  const [rooms, setRooms] = useState([]);
  const [ratePlans, setRatePlans] = useState({});
  const [closeout, setCloseout] = useState({});
  const [availability, setAvailability] = useState({});
  const [rentPerDayByDate, setRentPerDayByDate] = useState({});
  const [minimumStay, setMinimumStay] = useState({});
  const [maximumStay, setMaximumStay] = useState({});

  useEffect(() => {
    const fetchRooms = async () => {
      try {
        const response = await axios.get("/api/rooms/getallrooms");
        setRooms(response.data);

        const initAvailability = {};
        const initRentPerDayByDate = {};
        const initCloseout = {};
        const initMinimumStay = {};
        const initMaximumStay = {};

        response.data.forEach((room) => {
          initAvailability[room._id] = room.availability || {};
          initRentPerDayByDate[room._id] = room.rentperdayByDate || {};
          initCloseout[room._id] = room.closeout || {};
          initMinimumStay[room._id] = room.minimumStay || {};
          initMaximumStay[room._id] = room.maximumStay || {};
        });

        setAvailability(initAvailability);
        setRentPerDayByDate(initRentPerDayByDate);
        setCloseout(initCloseout);
        setMinimumStay(initMinimumStay);
        setMaximumStay(initMaximumStay);
      } catch (err) {
        console.error("Error fetching rooms:", err.message);
      }
    };

    const fetchRatePlans = async () => {
      try {
        const response = await axios.get("/api/rateplans/getallrateplans");
        const ratePlansByRoom = {};
        const filteredRatePlans = response.data.filter(
          (plan) => !plan.closeout
        );
        filteredRatePlans.forEach((plan) => {
          plan.room.forEach((roomId) => {
            if (!ratePlansByRoom[roomId]) {
              ratePlansByRoom[roomId] = [];
            }
            ratePlansByRoom[roomId].push(plan);
          });
        });

        setRatePlans(ratePlansByRoom);
      } catch (err) {
        console.error("Error fetching rate plans:", err.message);
      }
    };

    fetchRooms();
    fetchRatePlans();
  }, []);

  return {
    rooms,
    ratePlans,
    closeout,
    availability,
    rentPerDayByDate,
    minimumStay,
    maximumStay,
    setCloseout,
    setAvailability,
    setRentPerDayByDate,
    setMinimumStay,
    setMaximumStay,
    setRatePlans,
  };
};
